module.exports = __webpack_public_path__ + "img/off_button.48228b2b.svg";